import { Notification } from './notification.model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<Notification> {
  isLoaded: boolean
  isLoading: boolean
  unreadCount: number
  isUnreadCountLoaded: boolean
  isUnreadCountLoading: boolean
}

export const adapter: EntityAdapter<Notification> = createEntityAdapter<Notification>({
  sortComparer: false,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  unreadCount: 0,
  isUnreadCountLoaded: false,
  isUnreadCountLoading: false,
})
